import Mutations from '../../odata/mutations';

export default { ...new Mutations('allUsers'), ...new Mutations('user') };
